import { _ } from "../../core/polyglot/polyglot.js";
import abstractInvoiceDocument from "./abstractInvoiceDocument.js";
import invoiceColumnsSpec from "./invoiceColumnsSpec.js";

/**
 * `accountsPayableDocument` is an accounting document responsible
 * for displaying invoices to be paid to a supplier.
 */
export default abstractInvoiceDocument.subclass((that, my) => {
	my.initialize = function (spec) {
		my.super(spec);

		that.title = _("Accounts payable");
	};

	my.getRepositoryRoute = function () {
		return "/Accounting2/Company/#companyId/InvoiceReport/AccountPayable";
	};

	my.getColumnSpec = function () {
		return invoiceColumnsSpec.payableColumnSpec();
	};

	that.hasPeriodPicker = function () {
		return false;
	};

	my.getHelpMessage = function () {
		return _(
			"This report lists the open accounts payable from the last import date. You can sort this list by clicking on the name of the column you want sorted.",
		);
	};
});
